
import { withInstall } from "../../utils/install";
import ADrawer from "./src/main.vue";
ADrawer.name = "ltADrawer";
export const ltADrawer = withInstall(ADrawer);
export default ltADrawer;

